import Vue from 'vue'
import api from '@/api'
import { normalize, schema } from 'normalizr'

// TODO: modularize normalization
const fieldTypeSchema = new schema.Entity('fieldTypes')
// fieldTypeSchema.define({ subfieldtypes: [ fieldTypeSchema ] })
const partSchema = new schema.Entity('parts')
const partsSchema = new schema.Array(partSchema)
partSchema.define({ parts: partsSchema, fieldtype: fieldTypeSchema })
const templateSchema = new schema.Entity('templates', { sections: partsSchema })

function generateAnswerKey (questionId, fieldTypeId, answerListId) {
  let answerKey = `${questionId}-${fieldTypeId}`
  if (answerListId) {
    answerKey = `${answerKey}-${answerListId}`
  }
  return answerKey
}

function partsSearchFU (part) {
  var thisCount = 0
  part.forEach(function(partObj) {
    if (partObj.parts) {
      thisCount += partsSearchFU(partObj.parts)
    } else {
      if (partObj.part_type === 'q') {
        if (partObj.is_list) {
          if (partObj.fieldtype.subfieldtypes.length > 0) {
            partObj.fieldtype.subfieldtypes.forEach(function(subfieldEach) {
              Object.keys(state.answers).forEach(function(answerSearch) {
                if (answerSearch.startsWith(partObj.id + '-' + subfieldEach.id + '-')) {
                  if (state.answers[answerSearch].status === 'follow up') {
                    thisCount++
                  }
                }
              })
            })
          }
        } else {
          if (partObj.fieldtype.subfieldtypes.length > 0) {
            partObj.fieldtype.subfieldtypes.forEach(function(subfieldEach) {
              if (state.answers[partObj.id + '-' + subfieldEach.id]) {
                if (state.answers[partObj.id + '-' + subfieldEach.id].status === 'follow up') {
                  thisCount++
                }
              }
            })
          } else {
            if (state.answers[partObj.id + '-' + partObj.fieldtype.id]) {
              if (state.answers[partObj.id + '-' + partObj.fieldtype.id].status === 'follow up') {
                thisCount++
              }
            }
          }
        }
      }
    }
  })
  return thisCount
}

const state = {
  answers: {},
  answerLists: {},
  saving: [],
  formStructure: [],
  failedSaves: [],
  readOnly: false,
  handleBypass: false,
  formSubmissionAttempt: false,
  files: "",
  uploadStatus: 0,
  uploadState: null,
  reviewEnabled: localStorage.getItem('answer-review') ? JSON.parse(localStorage.getItem('answer-review')) : true,
  signed: [],
  parts: [],
  fieldTypes: [],
  localSigning: false,
  adoptedSignature: null,
  userLocation: null
}

const getters = {
  answer: (state) => (questionId, fieldTypeId, answerListId) => {
    const answerKey = generateAnswerKey(questionId, fieldTypeId, answerListId)
    return state.answers[answerKey]
  },
  parts: (state) => {
    return state.parts
  },
  answerKey: () => (questionId, fieldTypeId, answerListId) => {
    return generateAnswerKey(questionId, fieldTypeId, answerListId)
  },
  signedForms: () => {
    return state.signed
  },
  answerList: (state) => (questionId) => state.answerLists[questionId] || [],
  pendingSaves: (state) => {
    return state.saving.length || state.failedSaves.length
  },
  errorSaves: (state) => {
    return state.failedSaves.length
  },
  getLocalSigning: (state) => {
    return state.localSigning
  },
  getAdoptSignature: (state) => {
    return state.adoptedSignature
  },
  getUserLocation: (state) => {
    return state.userLocation
  },
  totalAnswersFU: (state) => {
    var count = 0
    for (var answerObj in state.answers) {
      if (state.answers[answerObj].status === 'follow up') {
        count++
      }
    }
    return count
  },
  sectionAnswersFU: (state) => (sectionId) => {
    var count = 0
    state.formStructure.forEach(function(sectionObj) {
      if (sectionObj.id === sectionId) {
        count += partsSearchFU(sectionObj.parts)
      }
    })
    return count
  },
  isReadOnly: (state) => {
    return state.readOnly
  },
  uploadStatus: (state) => {
    return state.uploadStatus
  },
  uploadState: (state) => {
    return state.uploadState
  },
  reviewEnabled: (state) => {
    return state.reviewEnabled
  }
}

const mutations = {
  setAnswerDatabase (state, answerdb) {
    state.answers = answerdb.answers
    var answerList = {}
    for (var listItem in answerdb.answerlists) {
      var listIndexes = []
      answerdb.answerlists[listItem].forEach(listId => {
        listIndexes.push({
          id: listId,
          uuid: null
        })
      })
      answerList[listItem] = listIndexes
    }
    state.answerLists = answerList
  },
  dropListItem (state, {questionId, listId}) {
    if (state.answerLists[questionId]) {
      var index = state.answerLists[questionId].findIndex(list => list.id === listId)
      if (index > -1)
        state.answerLists[questionId].splice(
          index,
          1
        )
    }
  },
  setNestedTemplate (state, template) {
    let normalized = normalize(template, templateSchema)
    state.parts = { ...state.parts, ...normalized.entities.parts }
    state.fieldTypes = { ...state.fieldTypes, ...normalized.entities.fieldTypes }
  },
  setSectionStructure (state, structure) {
    state.formStructure = structure
  },
  setLocalSigning (state, local_signing) {
    state.localSigning = local_signing
  },
  setAdoptSignature (state, data) {
    state.adoptedSignature = data
  },
  setLocation (state, data) {
    state.userLocation = data
  },
  updateAnswer (state, { questionId, fieldTypeId, listId, answer }) {
    const answerKey = generateAnswerKey(questionId, fieldTypeId, listId)
    if (state.answerLists[questionId]) {
      if (state.answerLists[questionId].filter(obj => {return obj.id == listId}).length == 0) {
        state.answerLists[questionId].push({
          id: listId,
          uuid: null
        })
      }
    }        
    Vue.set(state.answers, answerKey, answer)
  },
  setSaving (state, payload) {
    state.saving.push(payload)
  },
  setSigned (state, payload) {
    state.signed.push(Number(payload))
  },
  unsetSaving (state, payload) {
    state.saving = state.saving.filter(item => item !== payload)
  },
  setSaveError (state, payload) {
    state.failedSaves.push(payload)
  },
  unsetSaveError (state, payload) {
    state.failedSaves = state.failedSaves.filter(item => item !== payload)
  },
  setReadOnly (state, payload) {
    state.readOnly = payload
  },
  setFileUpload (state, payload) {
    state.files = payload
  },
  setUploadStatus (state, payload) {
    state.uploadStatus = payload
  },
  setUploadState (state, payload) {
    state.uploadState = payload
  },
  setReviewEnabled: (state, payload) => {
    state.reviewEnabled = payload
    localStorage.setItem('answer-review', payload)
  }
}

const actions = {
  saveAnswer ({ commit }, { userFormId, questionId, fieldTypeId, listId, answer, isClient = false, uuid }) {
    const payload = {
      answer,
      fieldtype_id: fieldTypeId,
      list_id: listId,
      client_id: uuid
    }
    var saveAction
    return new Promise((resolve, reject) => {
      commit('unsetSaveError', generateAnswerKey(questionId, fieldTypeId, uuid))
      if (isClient) {
        saveAction = api.userform.contactUserForm.saveAnswer(userFormId, questionId, payload)
          .then(answer => {
            commit('updateAnswer',
                   { questionId, fieldTypeId, listId: answer.answerlist_id, answer })
            commit('unsetSaving', saveAction)
            resolve(answer)
          })
          .catch(error => {
            commit('unsetSaving', saveAction)
            commit('setSaveError', generateAnswerKey(questionId, fieldTypeId, uuid))
            reject(error)
          })
      } else {
        saveAction = api.userform.userForm.saveAnswer(userFormId, questionId, payload)
          .then(answer => {
            commit('updateAnswer',
                   { questionId, fieldTypeId, listId: answer.answerlist_id, answer })
            commit('unsetSaving', saveAction)
            resolve(answer)
          })
          .catch(error => {
            commit('unsetSaving', saveAction)
            commit('setSaveError', generateAnswerKey(questionId, fieldTypeId, uuid))
            reject(error)
          })
      }
      commit('setSaving', saveAction)
    })
  },
  saveFileAnswer ({ commit }, { userFormId, isClient = false, answerObject }) {
    var saveAction
    return new Promise((resolve, reject) => {
      commit('unsetSaveError', generateAnswerKey(answerObject.get('question_id'), answerObject.get('fieldtype_id'), answerObject.get('client_id')))
      if (isClient) {
        api.userform.contactUserForm.saveFileAnswer(userFormId, answerObject)
          .then(answer => {
            commit('updateAnswer',
                   { questionId: answerObject.get('question_id'), fieldTypeId: answerObject.get('fieldtype_id'), listId: answer.answerlist_id, answer })
            commit('unsetSaving', saveAction)
            resolve(answer)
          })
          .catch(error => {
            commit('unsetSaving', saveAction)
            commit('setSaveError', generateAnswerKey(answerObject.get('question_id'), answerObject.get('fieldtype_id'), answerObject.get('client_id')))
            reject(error)
          })
      } else {
        api.userform.userForm.saveFileAnswer(userFormId, answerObject)
          .then(answer => {
            commit('updateAnswer',
                   { questionId: answerObject.get('question_id'), fieldTypeId: answerObject.get('fieldtype_id'), listId: answer.answerlist_id, answer })
            commit('unsetSaving', saveAction)
            resolve(answer)
          })
          .catch(error => {
            commit('unsetSaving', saveAction)
            commit('setSaveError', generateAnswerKey(answerObject.get('question_id'), answerObject.get('fieldtype_id'), answerObject.get('client_id')))
            reject(error)
          })
      }
      commit('setSaving', saveAction)
    })
  },
  updateAnswerStatus ({ commit },
                      { userFormId, questionId, fieldTypeId, listId, clientId, status }) {
    return new Promise((resolve, reject) => {
      api.userform.userForm.changeAnswerStatus(
        userFormId, questionId, fieldTypeId, listId, clientId, status
      )
        .then(answer => {
          commit('updateAnswer',
                 { questionId, fieldTypeId, listId: answer.answerlist_id, answer })
          resolve(answer)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  uploadClientFiles ({commit}) {
    return new Promise((resolve, reject) => {
      api.userform.contactFiles.uploadFiles(state.files, (uploadEvent) => {
        commit('setUploadStatus', Math.round((uploadEvent.loaded * 100) / uploadEvent.total))
      })
      .then(uploads => {
        commit('setUploadStatus', 0)
        resolve(uploads)
      })
      .catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
